import { RsuiteModal } from "@components/adapters/rsuite/Modal";
import type { ModalProps } from "@components/contracts/Modal.types";

export const Modal: React.FC<ModalProps> = (props) => (
  <RsuiteModal {...props} />
);

export type { ModalProps };
